import View from "./view.js";
import { esc } from "../escape.js";
import { itemImageSrc } from "../itemVisual.js";
import { formatMoney } from "../currency.js";

class NewOrderItemView extends View {
  _parentElement = document.querySelector(".modal-parent");
  _itemModal = document.querySelector(".item-modal-overlay");
  _itemModalCloseBtn = document.querySelector(".item-modal-close");
  _quantityBtn = document.querySelector(".quantity-buttons");
  _basket;
  _qty = 1;
  _variants;

  _addHandlerShowItemModal(handler) {
    this._parentElement.addEventListener("click", (e) => {
      e.preventDefault();
      // The stock-alert chip on a card opens its own popover, not the item.
      if (e.target.closest(".pos-stock-chip")) return;
      const item = e.target.closest(".pos-item-card");
      if (!item) return;
      item.classList.remove("pulse");
      void item.offsetWidth;
      item.classList.add("pulse");
      handler(item.dataset.id);
      this._itemModal.classList.toggle("hidden");
    });
  }

  _itemModalContentUpdate(item) {
    this._adding = false; // fresh item modal - clear any stale add-in-progress flag
    const variantsSection = this._itemModal.querySelector(".variant-section");

    this._itemModal.querySelector(".title").textContent = item.itemName;
    this._itemModal.querySelector(".item-price").textContent = formatMoney(item.price);

    const imgEl = this._itemModal.querySelector(".item-image");
    if (imgEl) {
      imgEl.src = itemImageSrc(item);
      imgEl.alt = item.itemName;
    }

    const itemVariants = item.hasVariants
      ? item.variants
          .map((variant) => {
            const [...optionsArr] = variant.options;
            return `
          <div class="variant-set">
            <div class="pos-variant-label">${esc(variant.optionLabel)}</div>
            <div class="variant-options">
              ${optionsArr
                .map(
                  (option) => `
                  <div class="variant-chip" data-value="${esc(option.optionName)}" data-price="${esc(option.optionPrice)}">
                    ${option.optionName !== "" ? esc(option.optionName) : `Unnamed option`}
                    <span>${option.optionPrice === "0" ? "" : `+${formatMoney(option.optionPrice)}`}</span>
                  </div>
                  `,
                )
                .join("")}
            </div>
          </div>
        `;
          })
          .join("")
      : ``;

    variantsSection.innerHTML = "";
    variantsSection.insertAdjacentHTML("afterbegin", itemVariants);

    this._selectMultipleVariantListener();

    this._basket = {
      itemName: item.itemName,
      price: item.price,
      imageURL: itemImageSrc(item),
      selectedVariants: [],
      variantsTotalPrice: "",
      category: item.category,
      id: item._id,
      lineId: null, // stable per-cart-line id, minted in controlPushToModelCart
      date: Date.now(),
      quantity: "",
      totalPrice: "",
      customerPayment: "",
      customerChange: "",
    };
  }

  _closeItemModal() {
    this._itemModalCloseBtn.addEventListener("click", function (e) {
      const overlay = document.querySelector(".item-modal-overlay");
      const inner = overlay.querySelector(".modal-content");
      if (inner) inner.classList.add("modal-exiting");
      setTimeout(() => {
        if (inner) inner.classList.remove("modal-exiting");
        overlay.classList.add("hidden");
      }, 220);
    });
  }

  _pushToCart(handler) {
    this._itemModal.addEventListener("click", (e) => {
      e.preventDefault();
      const btn = e.target.closest("#btn-add-to-cart");
      if (!btn) return;
      // The modal stays open for a 220ms close animation after a click. Ignore
      // any extra clicks during that window so a double-click can't add the item
      // twice. (withSubmitGuard can't help here - the add is synchronous and
      // in-memory, so its flag clears before a second physical click lands.)
      if (this._adding) return;
      this._adding = true;
      this._findSelectedVariants();
      handler();
      const overlay = document.querySelector(".item-modal-overlay");
      const inner = overlay.querySelector(".modal-content");
      if (inner) inner.classList.add("modal-exiting");
      setTimeout(() => {
        if (inner) inner.classList.remove("modal-exiting");
        overlay.classList.add("hidden");
        this._qty = 1;
        document.getElementById("item-qty").textContent = this._qty;
        this._adding = false;
      }, 220);
    });
  }

  _adjustQuantity() {
    this._quantityBtn.addEventListener("click", (e) => {
      const btn = e.target.closest(".qty-btn");
      if (!btn) return;
      if (btn.dataset.action === "increase") {
        this._qty++;
        document.getElementById("item-qty").textContent = this._qty;
      }
      if (btn.dataset.action === "decrease") {
        this._qty >= 2 ? this._qty-- : (this._qty = 1);
        document.getElementById("item-qty").textContent = this._qty;
      }
    });
  }

  _selectMultipleVariantListener() {
    document
      .querySelector(".variant-section")
      .addEventListener("click", (e) => {
        e.preventDefault();
        const chip = e.target.closest(".variant-chip");
        if (!chip) return;
        chip.classList.toggle("selected");
        e.stopImmediatePropagation();
      });
  }

  _selectSingleVariantListener() {
    document.querySelectorAll(".variant-set").forEach((set) => {
      set.addEventListener("click", function (e) {
        const chip = e.target.closest(".variant-chip");
        if (!chip) return;
        const currentlySelected = set.querySelector(".variant-chip.selected");
        if (currentlySelected && currentlySelected !== chip) {
          currentlySelected.classList.remove("selected");
        }
        chip.classList.toggle("selected");
      });
    });
  }

  _findSelectedVariants() {
    this._variants = Array.from(
      document
        .querySelector(".variant-section")
        .querySelectorAll(".variant-chip.selected"),
    ).map((el) => {
      return { variantName: el.dataset.value, variantPrice: el.dataset.price };
    });
  }
}

export default new NewOrderItemView();
